import React from 'react';
import i18n from 'i18n-js';

import PropTypes from 'prop-types';
import { BaseModal } from 'components/UI';
import { Button, Typography, Box, Grid } from '@mui/material';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';

const BrokerConnectSuccessModal = ({ open, onClose }) => {
  return (
    <BaseModal size="xl" open={open} enableCloseButton={false} handleClick={onClose}>
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" p={3}>
        <LibraryAddCheckIcon color="primary" sx={{ fontSize: 40 }} />
        <Box
          mt={2}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          textAlign="center"
        >
          <Typography variant="h6" gutterBottom color="primary">
            {i18n.t('organization.broker_connect.success_title')}
          </Typography>
          <Typography variant="body1" gutterBottom>
            {i18n.t('organization.broker_connect.success_description')}
          </Typography>
        </Box>

        <Box mt={6} />

        <Grid item container xs={5} justifyContent="center" alignItems="center">
          <Button variant="contained" color="primary" onClick={onClose} fullWidth>
            {i18n.t('common.close')}
          </Button>
        </Grid>
      </Box>
    </BaseModal>
  );
};

BrokerConnectSuccessModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export { BrokerConnectSuccessModal };
